import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class MarvStringService {
    
    constructor() { }
    
    static RemoveAccents(value: string) {
        if (value) {
            let value_norm = value.normalize('NFD').replace(/\p{Diacritic}/gu, '');
            return value_norm;
        }
        return '';
    }
}
